<template>
 <div id="payRecords">
  <div class="opreationBox">
   <div class="reacords-title">
    <el-row :gutter="24">
     <el-col :span="16">
      <el-descriptions title="" :column="4" border>
       <el-descriptions-item label="充值总额" content-class-name="green-content"
        >1000</el-descriptions-item
       >
       <el-descriptions-item
        label="已提现金额"
        content-class-name="green-content"
        >12</el-descriptions-item
       >
       <el-descriptions-item label="未到账总额" content-class-name="content"
        >43</el-descriptions-item
       >
       <el-descriptions-item label="余额" content-class-name="red-content">
        100
       </el-descriptions-item>
      </el-descriptions>
     </el-col>
     <el-col :span="8"
      ><el-button type="primary" @click="handleAdd">新增记录</el-button></el-col
     >
    </el-row>
   </div>
  </div>
  <div class="tableBox">
   <el-table
    v-loading="loading"
    :height="tableH"
    :data="recordList"
    border
    style="width: 100%"
   >
    <el-table-column
     header-align="center"
     align="center"
     label="充值金额"
     prop="amount"
    >
    </el-table-column>
    <el-table-column header-align="center" align="center" label="创建时间">
     <template slot-scope="scope">
      <span>{{ scope.row.createTime }}</span>
     </template>
    </el-table-column>
    <el-table-column header-align="center" align="center" label="确认时间">
     <template slot-scope="scope">
      <span>{{ scope.row.comfirmTime }}</span>
     </template>
    </el-table-column>
    <el-table-column
     header-align="center"
     align="center"
     label="充值人"
     prop="oprator"
    >
    </el-table-column>
    <el-table-column header-align="center" align="center" label="状态">
     <template slot-scope="scope">
      <template v-for="(item, index) in stateList">
       <span
        :key="index"
        :style="{ color: item.color }"
        v-if="item.value == scope.row.state"
        >{{ item.label }}</span
       >
      </template>
     </template>
    </el-table-column>
    <el-table-column
     header-align="center"
     align="center"
     fixed="right"
     label="操作"
     width="150"
    >
     <template slot-scope="scope">
      <el-button
       :disabled="!!scope.row.state"
       @click="recordsConfirm(scope.row)"
       size="mini"
       plain
       >确认</el-button
      >
     </template>
    </el-table-column>
   </el-table>
  </div>
  <div class="pageBox">
   <el-pagination
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageObj.PageIndex"
    :page-sizes="[2, 4, 10, 20, 50, 100]"
    :page-size="pageObj.PageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pageObj.total"
   >
   </el-pagination>
  </div>
  <el-dialog
   @close="close"
   title="添加充值记录"
   :visible.sync="dialogVisible"
   width="30%"
  >
   <el-form ref="form" :rules="rules" :model="form" label-width="80px">
    <el-form-item label="金额" prop="amount">
     <el-input v-model="form.amount"></el-input>
    </el-form-item>
   </el-form>
   <div slot="footer" class="dialog-footer">
    <el-button @click="close">取 消</el-button>
    <el-button type="primary" @click="submitAdd">确 定</el-button>
   </div>
  </el-dialog>
 </div>
</template>

<script>
import {
 getRechargeRecord,
 addRechargeRecord,
 updateRechargeRecord,
 getMoneyStatistics,
} from 'api/request'
import { SetTableH } from '../../utils/utils'
export default {
 data() {
  return {
   loading: false,
   tableH: '250',
   dialogVisible: false,
   pageObj: {
    total: 0,
    PageIndex: 1,
    PageSize: 10,
   },
   recordList: [],
   stateList: [
    {
     value: 0,
     label: '未确认',
     color: '#f56c6c',
    },
    {
     value: 1,
     label: '已确认',
     color: '#67c23a',
    },
   ],
   form: {
    amount: '',
   },
   rules: {
    amount: [
     { required: true, message: '请输入金额', trigger: 'blur' },
     { validator: this.numberValidate, trigger: 'blur' },
    ],
   },
  }
 },
 methods: {
  handleSizeChange(val) {
   this.pageObj.PageSize = val
   this.getRecordList()
  },
  handleCurrentChange(val) {
   this.pageObj.PageIndex = val
   this.getRecordList()
  },
  async getRecordList() {
   let params = {
    PageIndex: this.pageObj.PageIndex,
    PageSize: this.pageObj.PageSize,
   }
   this.loading = true
   let data = await getRechargeRecord(params)
   if (data) {
    this.recordList = data.rows
    this.pageObj.total = data.total
    this.loading = false
   }
  },
  async recordsConfirm(parmas) {
   this.$confirm(`请你确定信息是否无误?`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
   })
    .then(() => {
     updateRechargeRecord(parmas).then((data) => {
      if (data) {
       this.$message({
        message: '确认成功',
        type: 'success',
       })
       this.getRecordList()
      } else {
       this.$message({
        message: '确认失败',
        type: 'error',
       })
      }
     })
    })
    .catch(() => {})
  },
  async getRecordsStatistics() {
   try {
    const res = await getMoneyStatistics()
    console.log(res)
   } catch (error) {
    console.log(error)
   }
  },
  handleAdd() {
   this.dialogVisible = true
  },
  submitAdd() {
   this.$refs['form'].validate(async (valid) => {
    if (valid) {
     let parmas = {
      amount: this.form.amount,
     }
     const res = await addRechargeRecord(parmas)
     if (res) {
      this.$message({
       message: '添加成功',
       type: 'success',
      })
     } else {
      this.$message({
       message: '添加失败',
       type: 'error',
      })
     }
     this.close()
    }
   })
  },
  numberValidate(rule, value, callback) {
   const reg = /^\d+(\.{0,1}\d+){0,1}$/
   if (!reg.test(value)) {
    callback(new Error('请输入非负数'))
   } else {
    callback()
   }
  },
  close() {
   this.form.amount = ''
   this.dialogVisible = false
  },
 },
 mounted() {
  SetTableH(this)
 },
 created() {
  // this.getRecordsStatistics()
  this.getRecordList()
 },
}
</script>
<style lang="scss">
#payRecords {
 height: 100%;
 width: 100%;
 .reacords-title {
  padding-bottom: 20px;
 }
 .pageBox {
  margin-top: 20px;
  text-align: right;
 }
 .content {
  font-weight: bold;
  color: #909399;
 }
 .green-content {
  color: #049ea3;
  font-weight: bold;
 }
 .red-content {
  color: rgb(245, 108, 108);
  font-weight: bold;
 }
}
</style>
